import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import Flag from "@/modules/vue/components/Flag.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CountryPicker',
  props: {
    modelValue: null,
    countries: null
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const renderCountryLabel = option => {
      return h('div', {
        class: 'leading-none h-full flex items-center'
      }, [h(Flag, {
        country: option.value,
        class: 'mr-1'
      }), h('div', {}, option.value)]);
    };
    return (_ctx, _cache) => {
      const _component_NSelect = _resolveComponent("NSelect");
      return _openBlock(), _createBlock(_component_NSelect, {
        value: __props.modelValue,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
        options: __props.countries.map(o => ({
          value: o,
          label: o
        })),
        "render-label": renderCountryLabel
      }, null, 8, ["value", "options"]);
    };
  }
});